module.exports = __webpack_public_path__ + "static/media/LearnCreatorHowItWorks2.4678f242.png";